import {InformacionEnum} from '../Enumeraciones/MensajeEnumeraciones.enum';

export class InformacionModel
{
  public Tipo:InformacionEnum = InformacionEnum.normal;
  public Icono:string = "";
  public Aceptar:boolean = true;
  public Mensaje:string = "";
  public Titulo:string = "";
  public SVG:boolean = false;
  public Size:string = "";
  public OrigenHTML:boolean = false;
  public Times:boolean = false;

  constructor(init?:Partial<InformacionModel>)
  {
    Object.assign(this, init);
  }

}
